import { render, staticRenderFns } from "./LockerCompaniesList.vue?vue&type=template&id=162d99dd&"
import script from "./LockerCompaniesList.vue?vue&type=script&lang=ts&"
export * from "./LockerCompaniesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports